import type { AnnouncerData, AnnouncerPhraseData } from './adminApi';

/** Locutores e falas ATIVOS (GET /api/announcers). Carregado uma vez por sessão. */
export interface AnnouncerBundle {
  announcers: AnnouncerData[];
  phrases: AnnouncerPhraseData[];
}

/** Versão das artes padrão em /announcers/ — subir ao redesenhar, para furar o cache do navegador. */
const DEFAULT_ART_VERSION = 2;

/** URL da arte para o <img>: as padrão ganham ?v=N; uploads já têm nome único. */
export function announcerArtUrl(image: string): string {
  return image.startsWith('/announcers/') ? `${image}?v=${DEFAULT_ART_VERSION}` : image;
}

let cache: Promise<AnnouncerBundle> | null = null;

export function loadAnnouncers(): Promise<AnnouncerBundle> {
  if (!cache) {
    cache = fetch('/api/announcers')
      .then(r => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((b: AnnouncerBundle) => ({ announcers: b.announcers ?? [], phrases: b.phrases ?? [] }))
      .catch(e => { cache = null; throw e; }); // falhou → tenta de novo na próxima
  }
  return cache;
}
